
import state from './moduleBatchClientsManagementState'
import mutations from './moduleBatchClientsManagementMutations'
import actions from './moduleBatchClientsManagementActions'
import getters from './moduleBatchClientsManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

